/** Shared block builders for Studio starter documents (project.ts, site-templates.ts). */

export const palette = ['#269A96', '#0b1517', '#3EB0AB', '#FFFDEE', '#ffffff'];

export const globals = () => ({
  id: 'globals',
  type: 'globals',
  settings: {
    colors: [...palette],
    fonts: ["'Onest Variable', sans-serif", "'Geist Variable', sans-serif"],
    pageBackground: '#ffffff',
    pageTextColor: '#0f172a',
    elementDefaults: {},
  },
});

export const contentSection = (id: string, title: string, text: string) => ({
  id,
  type: 'row',
  customName: title,
  settings: { columns: 1, mobileColumns: 1, alignItems: 'center' },
  styles: { paddingTop: 64, paddingBottom: 64, backgroundColor: '#ffffff' },
  children: [{
    id: `${id}-column`,
    type: 'container',
    customName: 'Treść',
    settings: {},
    styles: { maxWidth: '900px' },
    children: [
      {
        id: `${id}-title`,
        type: 'header',
        content: title,
        settings: { level: 'h1' },
        styles: { fontSize: 48, fontWeight: 800, textAlign: 'center', color: '#0f172a', marginBottom: 16 },
      },
      {
        id: `${id}-text`,
        type: 'text',
        content: text,
        settings: {},
        styles: { fontSize: 18, textAlign: 'center', color: '#475569', marginBottom: 28 },
      },
      {
        id: `${id}-button`,
        type: 'button',
        content: 'Zobacz ofertę',
        settings: { actionType: 'link', href: '/produkty', target: '_self' },
        styles: { backgroundColor: '#2563eb', color: '#ffffff', borderRadius: 999, textAlign: 'center' },
      },
    ],
  }],
});

export const legalPage = (id: string, title: string, lead: string) => [
  globals(),
  {
    id: `${id}-hero`,
    type: 'container',
    customName: 'Nagłówek dokumentu',
    settings: {},
    styles: { paddingTop: 56, paddingBottom: 32, backgroundColor: '#f7f5f0' },
    children: [
      { id: `${id}-eyebrow`, type: 'text', content: 'INFORMACJE PRAWNE', settings: {}, styles: { color: '#b8471a', fontSize: 12, fontWeight: 800, letterSpacing: '0.12em', marginBottom: 12 } },
      { id: `${id}-title`, type: 'header', content: title, settings: { level: 'h1' }, styles: { color: '#1f2933', fontSize: 42, fontWeight: 750, lineHeight: 1.12, marginBottom: 14 } },
      { id: `${id}-lead`, type: 'text', content: lead, settings: {}, styles: { color: '#5b6570', fontSize: 16, lineHeight: 1.7, maxWidth: 760 } },
    ],
  },
  {
    id: `${id}-body`,
    type: 'container',
    customName: 'Treść dokumentu',
    settings: {},
    styles: { maxWidth: '920px', paddingTop: 40, paddingBottom: 72, backgroundColor: '#ffffff' },
    children: [{
      id: `${id}-content`,
      type: 'text',
      content: '<h2>Uzupełnij treść dokumentu</h2><p>Wklej zatwierdzoną treść prawną. Zachowaj krótkie akapity, czytelne nagłówki i numerowane sekcje.</p>',
      settings: {},
      styles: { color: '#334155', fontSize: 15, lineHeight: 1.85 },
    }],
  },
];

export const informationPage = (id: string, title: string, lead: string) => [
  globals(),
  {
    id: `${id}-hero`,
    type: 'container',
    customName: 'Wprowadzenie',
    settings: {},
    styles: { paddingTop: 58, paddingBottom: 36, backgroundColor: '#f7f5f0' },
    children: [
      { id: `${id}-title`, type: 'header', content: title, settings: { level: 'h1' }, styles: { color: '#1f2933', fontSize: 42, fontWeight: 750, lineHeight: 1.15, marginBottom: 14 } },
      { id: `${id}-lead`, type: 'text', content: lead, settings: {}, styles: { color: '#5b6570', fontSize: 17, lineHeight: 1.7, maxWidth: 780 } },
    ],
  },
  {
    id: `${id}-body`,
    type: 'container',
    customName: 'Treść strony',
    settings: {},
    styles: { maxWidth: '980px', paddingTop: 44, paddingBottom: 72, backgroundColor: '#ffffff' },
    children: [{ id: `${id}-content`, type: 'text', content: '<h2>Treść strony</h2><p>Uzupełnij informacje i dostosuj je do aktualnej oferty sklepu.</p>', settings: {}, styles: { color: '#334155', fontSize: 16, lineHeight: 1.8 } }],
  },
];
